import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=ccb44cd2&scoped=true&lang=css"
import "./Checkbox.vue?vue&type=style&index=1&id=ccb44cd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccb44cd2"]])

export default __exports__